import { createContext, useContext, useEffect, useMemo } from "react";
import { useNavigation } from "../hooks/useQueryCustom";
import UserContext from "./user";
import { ECOMMERCE_MODE, NOFESTIVAL_MODE } from "../utils/constants";

const NavigazioneContext = createContext({
  pages: [],
  topMenu: [],
  footer: [],
  mode: null,
  earlyBirdPremium: false,
  linkVideo: null,
  imgEdizione: null,
  bannerOrientamento: null,
  sponsor: false,
  programma: null,
  isLoading: false,
  isError: false,
  testata: null,
  testataMobile: null,
});

export const NavigazioneProvider = ({ children }) => {
  const { isAdmin } = useContext(UserContext);
  const { data, isLoading, isError } = useNavigation(isAdmin);
  //console.log("NavigazioneProvider", data);
  const contextValue = useMemo(() => {
    const topMenu = data ? data.topMenu : [];
    const pages = data ? data.pages : [];
    const footer = data?.footer;
    const linkVideo = data?.linkVideo;
    const mode = isAdmin ? ECOMMERCE_MODE : data?.mode || NOFESTIVAL_MODE;
    const imgEdizione = data?.imgEdizione;
    const testata = data?.testata;
    const earlyBirdPremium = data?.earlyBirdPremium;
    const testataMobile = data?.testataMobile;
    const sponsor = data?.sponsor || false;
    const programma =
      import.meta.env.VITE_URL_PROGRAMMA_PDF || data?.programma || null;
    const bannerOrientamento = data?.bannerOrientamento || null;
    const getPathByTemplate = (template) => {
      return getPageByTemplate(template)?.link || "#";
    };
    const getPageByTemplate = (template) => {
      return pages?.find((page) => page.template === template) || null;
    };
    const getLink = (item) => {
      if (item?.idEvento) {
        const programmaPage = getPathByTemplate("programma");
        return `${programmaPage}/id-${item.idEvento}/`;
      }
      if (item?.linkEsterno) return item.linkEsterno;
      if (item?.file?.url) return item.file.url;

      return item.__typename === "Articolo"
        ? `/news/${item.slug}/`
        : `/${item.slug}`;
    };

    return {
      pages,
      mode,
      topMenu,
      footer,
      linkVideo,
      sponsor,
      programma,
      bannerOrientamento,
      imgEdizione,
      isLoading,
      testata,
      testataMobile,
      earlyBirdPremium,
      isError,
      getLink,
      getPathByTemplate,
      getPageByTemplate,
    };
  }, [data, isLoading, isError, isAdmin]);

  useEffect(() => {
    if (data?.mainColor) {
      //console.log("set main color");
      document.documentElement.style.setProperty("--fds-color", data.mainColor);
    }
  }, [data]);

  return (
    <NavigazioneContext.Provider value={contextValue}>
      {children}
    </NavigazioneContext.Provider>
  );
};

export const useNavigazione = () => {
  return useContext(NavigazioneContext);
};

export default NavigazioneContext;
